import {mainJsHok} from "@/services/auth/Auth.js";

console.log('Hajcer app 20 main.js')
mainJsHok()

import './assets/style/main.scss'

import {createApp} from 'vue'
import {createPinia} from 'pinia'

import App from './App.vue'
import router from './router'

const app = createApp(App)

app.use(createPinia())
app.use(router)

import InstallPlugin from "@/utils/Install"
import { definePreset } from '@primevue/themes';
import PrimeVue from 'primevue/config'
import Aura from '@primevue/themes/aura'

const MyPreset = definePreset(Aura, {
    semantic: {
        primary: {
            '50': '#fafafa',
            '100': '#f4f4f5',
            '200': '#e4e4e7',
            '300': '#d4d4d8',
            '400': '#a1a1aa',
            '500': '#71717a',
            '600': '#52525b',
            '700': '#3f3f46',
            '800': '#27272a',
            '900': '#18181b',
            '950': '#09090b'
        },
        colorScheme: {
            light: {
                primary: {
                    color: '{zinc.950}',
                    inverseColor: '#ffffff',
                    hoverColor: '{zinc.900}',
                    activeColor: '{zinc.800}'
                },
            }
        }
    }
});

app.use(PrimeVue, {
    theme: {
        preset: MyPreset,
        options: {
            // prefix: 'tw-',
            darkModeSelector: 'none',
            cssLayer: {
                name: 'primevue',
                order: 'tailwind-base, primevue, tailwind-utilities'
            },
        }
    },

});


import ToastService from 'primevue/toastservice';

app.use(ToastService);
import ConfirmationService from 'primevue/confirmationservice';

app.use(ConfirmationService);


const startApp = async () => {
    await InstallPlugin(app)
    app.mount('#app')
}

startApp().finally(() => console.log('App started'))